import {Component, OnInit} from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import {FuseConfigService} from '../../../../core/services/config.service';
import {ModulesService} from '../../../../core/services/modules.service';

@Component({
    selector: 'org-modules',
    templateUrl: './org-modules.component.html',
    styleUrls: ['./org-modules.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class OrgModulesComponent implements OnInit {
  modules = [];
  displayedColumns = [ 'title', 'status', 'description', 'infoUrl'];
  organizationId;
  constructor(public modulesService: ModulesService,
              private fuseConfig: FuseConfigService) {
    this.fuseConfig.organizationId.subscribe((res) => {
      if (res) {
        this.organizationId = parseInt(res, 10);
        this.getModules();
      }
    });
  }

  ngOnInit() {

  }

  getModules() {
    this.modulesService.getByOrganizationId(this.organizationId).subscribe((res: any) => {
      this.modules = res;
    });
  }
}
